import CloseMapOverlay from '../components/CloseMapOverlay';

export default function Library() {
  return (
    <div
      className="flex flex-col flex-grow w-full overflow-auto"
      style={{ height: 'calc(100vh - 72px)' }}
    >
      <div className="absolute right-0 z-10 p-[1px]">
        <div className="btn btn-neutral rounded-full px-3">
          <CloseMapOverlay className="fill-neutral-content p-0" size="24px" />
        </div>
      </div>
      <iframe src="https://lore.nootopia.app" width="100%" height="100%" />
    </div>
  );
}
